// Constants to avoid circular dependencies

export const TriggerKind = {
  reschedule: 'event_details',
  contact: 'contact_profile',
  contacts_list: 'contacts_list',
  eventType: 'et_card',
  sul: 'sul',
  bookingPage: 'booking_page',
  inviteeDetailsReschedule: 'invitee_details'
}

export const SEND_FROM_CALENDLY_Q1_ET_CARD_SUL = 'send_from_calendly_q1_et_card_sul'
export const SEND_FROM_CALENDLY_BILLING_KEY = 'send_from_calendly'
